import React, { createContext, useContext } from 'react';
import PALETTES from './palettes';
import DENSITY from './density';
import FONTS from './fonts';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const p = PALETTES.bone;
  const d = DENSITY.comfortable;

  return (
    <ThemeContext.Provider value={{ p, d, fonts: FONTS }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
}

export default ThemeContext;
